export function customAddToCart() {
    $('.custom_add_to_cart').click(function (e) {
        e.preventDefault();

        let data = {
            product_id: $(this).attr('data-product'),
            quantity: $(this).closest('.tribe-tickets-form-row').find('.qty').val()
        };

        // $(this).parent().addClass('loading');

        $.post(wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'), data, function (response) {

            if (!response) {
                return;
            }

            if (response.error) {
                alert("Custom Massage ");
                // $('.custom_add_to_cart').parent().removeClass('loading');
                return;
            }

            if (response) {
                let url = woocommerce_params.wc_ajax_url;
                url = url.replace("%%endpoint%%", "get_refreshed_fragments");

                $.post(url, function (data, status) {
                    $(".holder-icon-cart").html(data.fragments["a.icon-cart"]);

                    // if (data.fragments) {
                    //     $.each(data.fragments, function (key, value) {
                    //         console.log(key);
                    //         $(key).replaceWith(value);
                    //     });
                    // }

                    $("body").removeClass('cart-empty').trigger("wc_fragments_refreshed");

                    $('.button.disabled').removeClass('disabled');
                });

                // $('.custom_add_to_cart').parent().removeClass('loading');
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/custom_add_to_cart.js